import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    planSampleExcel: {
        data: null,
        error: null,
        loading: null,
    },
    planResultUpload: {
        data: null,
        error: null,
        loading: null,
    },
    pdfData: null,
    sampleExcel: {
        data: null,
        error: null,
        loading: null,
    },
    importExcelData: {
        data: null,
        error: null,
        loading: null,
    },
    exportExcelData: {
        data: null,
        error: null,
        loading: null,
    },
};

const excelSlice = createSlice({
    name: "excel",
    initialState,
    reducers: {
        downloadSampleFileRequest: (state, action) => {
            state.planSampleExcel.loading = true;
        },
        downloadSampleFileSuccess: (state, action) => {
            state.planSampleExcel.loading = false;
            state.planSampleExcel.data = action.payload;
        },
        downloadSampleFileFailure: (state, action) => {
            state.planSampleExcel.loading = false;
            state.planSampleExcel.error = action.payload;
        },
        uploadPlanExcelRequest: (state) => {
            state.planResultUpload.loading = true;
        },
        uploadPlanExcelSuccess: (state, action) => {
            state.planResultUpload.loading = false;
            state.planResultUpload.data = action.payload;
        },
        uploadPlanExcelFailure: (state, action) => {
            state.planResultUpload.loading = false;
            state.planResultUpload.error = action.payload;
        },
        getPdfDataNew: (state, action) => {
            state.loading = true;
        },
        getPdfDataNewSuccess: (state, action) => {
            state.loading = false;
            state.pdfData = action.payload.data;
            state.error = null;
        },
        getPdfDataNewFail: (state, action) => {
            state.loading = false;
            state.pdfData = null;
            state.error = action.payload;
        },
        getSampleExcel: (state, action) => {
            state.loading = true;
        },
        getSampleExcelSuccess: (state, action) => {
            state.loading = false;
            state.sampleExcel.data = action.payload;
            state.sampleExcel.error = null;
        },
        getSampleExcelFail: (state, action) => {
            state.loading = false;
            state.sampleExcel.data = null;
            state.sampleExcel.error = action.payload;
        },
        importExcel: (state, action) => {
            state.loading = true;
        },
        importExcelSuccess: (state, action) => {
            state.loading = false;
            state.importExcelData.data = action.payload;
            state.importExcelData.error = null;
        },
        importExcelFail: (state, action) => {
            state.loading = false;
            state.importExcelData.data = null;
            state.importExcelData.error = action.payload;
        },
        exportExcel: (state) => {
            state.exportExcelData.loading = true;
        },
        exportExcelSuccess: (state, action) => {
            state.exportExcelData.loading = false;
            state.exportExcelData.data = action.payload;
            state.exportExcelData.error = null;
        },
        exportExcelFail: (state, action) => {
            state.exportExcelData.loading = false;
            state.exportExcelData.data = null;
            state.exportExcelData.error = action.payload;
        },
        clearDataExcel: (state) => {
            state.planSampleExcel.data = null;
            state.planSampleExcel.error = null;
            state.planResultUpload.data = null;
            state.planResultUpload.error = null;
            state.sampleExcel.data = null;
            state.sampleExcel.error = null;
            state.importExcelData.data = null;
            state.importExcelData.error = null;
            state.exportExcelData.data = null;
            state.exportExcelData.error = null;
            state.pdfData = null;
        },
    },
});

export const {
    downloadSampleFileRequest,
    downloadSampleFileSuccess,
    downloadSampleFileFailure,
    uploadPlanExcelRequest,
    uploadPlanExcelSuccess,
    uploadPlanExcelFailure,
    getPdfDataNew,
    getPdfDataNewSuccess,
    getPdfDataNewFail,
    getSampleExcel,
    getSampleExcelFail,
    getSampleExcelSuccess,
    importExcel,
    importExcelSuccess,
    importExcelFail,
    exportExcel,
    exportExcelFail,
    exportExcelSuccess,
    clearDataExcel,
} = excelSlice.actions;
export default excelSlice.reducer;
